export default "__VITE_ASSET__BdVzCOXn__"